import { IconButton, Box, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames'
import styles from './styles';

function EquipmentOrderGroupHeader({ classes, group, groupName, collapsed, onClick, dragging }) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: group._id,
    data: { type: 'group' },
    disabled: false,
  });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    borderColor: group.color,
    backgroundColor: dragging ? group.color : 'transparent'
  };
  return (
    <Box className={classes.groupHeaderWrapper}>
      <Box
        ref={setNodeRef}
        className={classnames(classes.groupHeader, dragging ? classes.groupHeaderDragging : null)}
        style={style}
        {...attributes}
        {...listeners}
      >
        <DragIndicatorIcon className={classes.dragIcon} />
        <Typography className={classes.groupHeaderText}>{groupName}</Typography>
        <IconButton onClick={() => onClick(group.color)} size="small">
          {collapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
        </IconButton>
      </Box>
      <Box className={classes.line} />
    </Box>
  );
}

export default withStyles(styles)(EquipmentOrderGroupHeader)